import { useEffect, useMemo } from "react"

/**
 * @description 微信消息和朋友圈分享配置
 * @param ready 是否可以进行配置
 * @param config 配置信息
 */
export default function useShare(ready, config) {
    let {
        imgUrl,
        desc,
        title,
    } = config || {};
    if (!desc) {
        desc = document.location.href;
    }

    const shareConfig = useMemo(
        () => {
            if (imgUrl && desc && title) {
                // 目前微信分享策略必须保证3项必填
                const link = window.location.href
                return {
                    imgUrl,
                    desc,
                    title,
                    link,
                }
            }
            return null
        },
        [
            imgUrl,
            desc,
            title,
        ]
    )

    useEffect(
        () => {
            if (ready && shareConfig) {
                // 配置消息分享
                window.wx.updateAppMessageShareData(shareConfig)
                // 配置朋友圈分享
                window.wx.updateTimelineShareData(shareConfig)
            }
        },
        [
            ready,
            shareConfig,
        ],
    )
}